export const MODULE = 'MISCELLANEOUS_FEE_LP';
export const LIST = `${MODULE}/list`;
export const ITEM = `${MODULE}/item`;
export const GET_TRANSACTION_COUNTS = 'TRANSACTION/get_transaction_counts';
